import React from 'react';
import Button from '../../components/Button/Button';

interface ILogoutConfirmationProps {
  closePopUp: () => void;
  handleLogout: () => void;
}

const LogoutConfirmation: React.FC<ILogoutConfirmationProps> = ({ closePopUp, handleLogout }) => {
  return (
    <>
      <p className="text-md text-ds-gray-500">
        Are you sure you want to logout? Logging out will remove your session and you will need to
        log in again to access your account.
      </p>

      <div className="mt-4 flex justify-end gap-2">
        <Button color="outlined" size="sm" onClick={closePopUp}>
          Cancel
        </Button>
        <Button size="sm" color="error" type="button" onClick={handleLogout}>
          Confirm
        </Button>
      </div>
    </>
  );
};

export default LogoutConfirmation;
